<template>
  <section id="lab_info" class="contact section">
    <div class="sec">
      <div class="c_title">{{ localized.title }}</div>
      <div class="c_subTitle">{{ localized.subtitle }}</div>
      <img class="pro_rcfw4" :src="require('@/static/image/pro_rcfw4.png')" alt="" />
    </div>
    <div class="form">
      <div class="form-item">
        <input v-model.trim="form.uname" class="input" id="company" type="text" :placeholder="localized.questionLabel" />
      </div>
      <div class="form-item">
        <input v-model.trim="form.phone" class="input" id="name" type="text" :placeholder="localized.nameLabel" />
      </div>
      <div class="form-item">
        <input v-model.trim="form.remark" class="input" id="phone" type="text" :placeholder="localized.phoneLabel" />
      </div>
      <div class="submit" @click="submit">{{ localized.submit }}</div>
      <div class="form-divider"></div>
      <div class="hotline">
        <span class="icon"></span>
        <span class="tel">{{ hotlineText }}</span>
        <span class="time">{{ localized.hotlineTime }}</span>
      </div>
    </div>
  </section>
</template>

<script>
import { submitProductConsultByLocale } from '@/api/collaborator'

export default {
  name: 'LaborContactForm',
  props: {
    contactForm: { type: Object, required: true }
  },
  data() {
    return {
      submitting: false,
      form: {
        uname: '',
        phone: '',
        remark: ''
      }
    }
  },
  computed: {
    isZhLocale() {
      const locale = (this.$i18n && this.$i18n.locale) || 'zh-CN'
      return locale === 'zh-CN'
    },
    hotlineText() {
      return this.isZhLocale ? '400 881 8590' : '827318324@qq.com'
    },
    localized() {
      return {
        title: this.$t(this.contactForm.titleKey),
        subtitle: this.$t(this.contactForm.subtitleKey),
        typeCompany: this.$t(this.contactForm.typeCompanyKey),
        typePerson: this.$t(this.contactForm.typePersonKey),
        questionLabel: this.$t(this.contactForm.questionLabelKey),
        nameLabel: this.$t(this.contactForm.nameLabelKey),
        phoneLabel: this.$t(this.contactForm.phoneLabelKey),
        submit: this.$t(this.contactForm.submitKey),
        hotlineTime: this.$t(this.contactForm.hotlineTimeKey)
      }
    }
  },
  methods: {
    notify(type, message) {
      if (this.$message) {
        this.$message({ type, message })
      } else {
        window.alert(message)
      }
    },
    async submit() {
      const { uname, phone, remark } = this.form

      if (uname.length < 2 || uname.length > 10) {
        this.notify('warning', this.$t('siteFooter.validateName'))
        return
      }

      if (!phone) {
        this.notify('warning', this.$t('siteFooter.validatePhone'))
        return
      }

      if (!remark) {
        this.notify('warning', this.$t('siteFooter.validateRemark'))
        return
      }

      if (this.submitting) return
      this.submitting = true

      try {
        const locale = (this.$i18n && this.$i18n.locale) || 'zh-CN'
        await submitProductConsultByLocale(locale, { name: uname, phone, company: remark })

        this.form.uname = ''
        this.form.phone = ''
        this.form.remark = ''
        this.notify('success', this.localized.submit)
      } catch (e) {
        this.notify('error', this.localized.submit)
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.section { width: 1200px; margin: 0 auto; }
.contact { margin: 64px auto 36px; display: grid; grid-template-columns: minmax(0, 1fr) 540px; align-items: start; background: linear-gradient(180deg, #f3f7ff 0%, #f7f9ff 100%); }
.sec { padding: 68px 0 0 92px; text-align: left; min-width: 0; }
.c_title { font-size: 38px; line-height: 1.15; font-weight: 500; color: #1f2a44; }
.c_subTitle { font-size: 15px; color: #7f8aa4; margin-top: 14px; }
.pro_rcfw4 { display: block; width: 100%; max-width: 900px; height: auto; margin-top: 44px; }
.form { width: 100%; margin: 0; position: relative; background: #fff; border: 1px solid #e8ebf2; box-sizing: border-box; }
.form-item { margin: 24px 0 0; padding: 0 38px; position: relative; }
.label { display: none; }
.input { width: 100%; height: 70px; border: 1px solid #edf0f5; padding: 0 22px; box-sizing: border-box; font-size: 16px; color: #1f2a44; background: #fff; }
.input::placeholder { color: #999; opacity: 1; }
.input:focus::placeholder { opacity: 0; }
.submit { margin: 28px 38px 0; background: #2758ab; color: #fff; text-align: center; height: 60px; line-height: 60px; border-radius: 30px; cursor: pointer; font-size: 18px; font-weight: 500; }
.form-divider { border-bottom: 1px solid #dfe4ed; margin: 28px 0 0; }
.hotline { display: flex; justify-content: flex-start; gap: 28px; color: #5f6b85; font-size: 15px; align-items: center; padding: 18px 34px 20px; }
.hotline .icon { width: 22px; height: 22px; border-radius: 50%; background: #6f7480; display: inline-block; position: relative; margin-right: -12px; }
.hotline .icon::before { content: ''; position: absolute; inset: 5px; border: 2px solid #fff; border-top-color: transparent; border-right-color: transparent; border-radius: 50%; transform: rotate(-45deg); }
.hotline .tel { color: #4a566f; font-size: 18px; white-space: nowrap; }
.hotline .time { color: #5f6b85; font-size: 14px; white-space: nowrap; }
</style>

